module.exports = __webpack_public_path__ + "static/img/home_logo.e9405147.png";